import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../../constants';
import * as D from '../../deps';

import './AlbumGridItemThirdLine.scss';

const AlbumGridItemThirdLine = props => {
  const { preText, mainText, mainTextUrl, Badge } = props;

  const getText = () => {
    const MainLink =
      mainText && mainTextUrl ? (
        <D.Link className='AlbumGridItemThirdLine__text__link' to={mainTextUrl}>
          {mainText}
        </D.Link>
      ) : null;

    if (MainLink && preText) {
      return (
        <React.Fragment>
          <FormattedMessage {...messages.hyphen} values={{ preText }} /> {MainLink}
        </React.Fragment>
      );
    }

    return MainLink || preText;
  };

  const Text = getText();

  return (
    <div className='AlbumGridItemThirdLine'>
      {Text && <div className='AlbumGridItemThirdLine__text'>{Text}</div>}
      {Badge && <div className='AlbumGridItemThirdLine__badge'>{Badge}</div>}
    </div>
  );
};

AlbumGridItemThirdLine.propTypes = {
  mainText: PropTypes.string,
  mainTextUrl: PropTypes.string,
  preText: PropTypes.string,
  Badge: PropTypes.node,
};

export default AlbumGridItemThirdLine;
